import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const AvatarIcon = createIcon({
    viewBox: '0 0 32 32',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M16 3.2002C23.0692 3.20022 28.7998 8.93078 28.7998 16C28.7998 23.0692 23.0692 28.7998 16 28.7998C8.93076 28.7998 3.2002 23.0692 3.2002 16C3.2002 8.93076 8.93076 3.2002 16 3.2002ZM16.0127 16.9854C15.2191 16.9854 14.3486 17.1007 13.4014 17.3311C12.3262 17.5999 11.4556 17.9583 10.79 18.4062C9.99653 18.931 9.59961 19.5201 9.59961 20.1729V21.7852H22.4258V20.1729C22.4258 19.5201 22.0289 18.931 21.2354 18.4062C20.5698 17.9583 19.6992 17.5999 18.624 17.3311C17.6768 17.1007 16.8063 16.9854 16.0127 16.9854ZM16.0127 8.95996C15.4367 8.95997 14.9053 9.10362 14.4189 9.3916C13.9325 9.6796 13.5458 10.074 13.2578 10.5732C12.9699 11.0724 12.8252 11.6096 12.8252 12.1855C12.8252 12.7615 12.9698 13.2929 13.2578 13.7793C13.5457 14.2655 13.9328 14.6525 14.4189 14.9404C14.9053 15.2284 15.4367 15.373 16.0127 15.373C16.5887 15.373 17.12 15.2284 17.6064 14.9404C18.0927 14.6525 18.4796 14.2655 18.7676 13.7793C19.0556 13.2929 19.2002 12.7615 19.2002 12.1855C19.2002 11.6096 19.0555 11.0724 18.7676 10.5732C18.4796 10.074 18.0928 9.6796 17.6064 9.3916C17.1201 9.10364 16.5887 8.95996 16.0127 8.95996Z'
                fill='currentColor'
            />
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0ZM16 1.28027C7.87037 1.28027 1.28027 7.87037 1.28027 16C1.28027 24.1296 7.87037 30.7197 16 30.7197C24.1296 30.7197 30.7197 24.1296 30.7197 16C30.7197 7.87037 24.1296 1.28027 16 1.28027Z'
                fill='currentColor'
            />
        </>
    ),
})

AvatarIcon.displayName = 'AvatarIcon'
